import React from 'react'
import { Link } from 'gatsby'
import styled from 'styled-components'
import { useMediaQuery } from 'react-responsive'
import Slider from 'react-slick'
import ReactTooltip from 'react-tooltip'
import { device } from '../Breakpoints'
import feto from '../../icons/feto.svg'
import bebe from '../../icons/bebe.svg'

const Color = {
  verde: '#8cc2b0',
  roxo: '#A4A5D3',
  laranja: '#EDB582',
  rosa: '#F1A6A4',
  amarelo: '#E3D48F',
}
const Container = styled.div`
  background: #f9f9f7;
  padding: 20px 20px 25px;
  width: 100%;
  @media ${device.mobileL} {
    margin: 20px 0;
    order: 2;
  }
  h2 {
    color: #a4a5d3;
    text-align: center;
    font-weight: 300;
    font-size: 1.2em !important;
  }
`
const LinhaDoTempo = styled.div`
  .verde {
    background-color: ${Color.verde};
  }
  .roxo {
    background-color: ${Color.roxo};
  }
  .laranja {
    background-color: ${Color.laranja};
  }
  .rosa {
    background-color: ${Color.rosa};
  }
  .amarelo {
    background-color: ${Color.amarelo};
  }
  ul {
    background: #ffffff;
    margin: 0 auto;
    border-radius: 50px;
    padding: 15px 20px 5px;
    text-align: center;
    position: relative;
    max-width: 1080px;
    ::before {
      content: url(${feto});
      position: absolute;
      left: 0;
      top: -10px;
      @media ${device.mobileL} {
        left: 45%;
        top: -25px;
      }
    }
    ::after {
      content: url(${bebe});
      position: absolute;
      right: 0;
      top: -14px;
      @media ${device.mobileL} {
        right: 42%;
        top: inherit;
        bottom: -35px;
      }
    }
    .tooltip {
      border-radius: 50px;
    }
    li {
      list-style: none;
      display: inline-block;
      @media ${device.mobileL} {
        display: block;
        margin: 2px 0;
      }
      a {
        display: block;
        text-indent: -9999px;
        border-radius: 50px;
        border: #ffffff solid 3px;
        padding: 0 6px;
        height: 12px;
        width: 0px;
        margin: 0 1px;
        color: #ffffff;
        text-decoration: none;
        @media ${device.mobileL} {
          height: 28px;
          width: 100%;
          box-sizing: border-box;
          text-indent: 0;
          padding: 2px 4px;
          font-size: 0.8em;
        }
        :hover {
          box-shadow: 0px 0px 2px #4a4a4a;
        }
      }
      .last {
        margin-right: 10px;
      }
    }
  }
  .slick-slider {
    background: #ffffff;
    border-radius: 50px;
    text-align: center;
    position: relative;
    margin: 2em 20px 0;
    padding: 50px 20px;
    a {
      color: #ffffff;
      text-decoration: none;
      border-radius: 50px;
      width: 27px !important;
      padding: 0.5em;
    }
    ::before {
      content: url(${feto});
      position: absolute;
      left: 0;
      top: -10px;
      @media ${device.mobileL} {
        left: 45%;
        top: -25px;
      }
    }
    ::after {
      content: url(${bebe});
      position: absolute;
      right: 0;
      top: -14px;
      @media ${device.mobileL} {
        right: 42%;
        top: inherit;
        bottom: -35px;
      }
    }
  }
`

function NextArrow() {
  return <></>
}
function PrevArrow() {
  return <></>
}
const Babypedia = ({ title }) => {
  const isMobile = useMediaQuery({ query: '(max-device-width: 425px)' })
  const notMobile = useMediaQuery({ query: '(min-device-width: 426px)' })
  return (
    <Container>
      {notMobile && (
        <LinhaDoTempo>
          {title ? (
            <>
              <h2>
                Babypedia: tudo o que você precisa saber com o olhar dos nossos
                especialistas
              </h2>
              <ul>
                <li>
                  <Link
                    to="/babypedia/semana-4-da-gravidez/"
                    data-tip="4 semanas de gravidez"
                    className="verde last"
                    data-for="tooltip-1"
                  >
                    4 semanas de gravidez
                  </Link>
                  <ReactTooltip
                    id="tooltip-1"
                    backgroundColor={Color.verde}
                    className="tooltip"
                    effect="solid"
                    place="bottom"
                    borderColor={Color.verde}
                    arrowColor={Color.verde}
                  />
                </li>
                <li>
                  <Link
                    to="/babypedia/semana-5-da-gravidez/"
                    data-tip="5 semanas de gravidez"
                    className="roxo"
                    data-for="tooltip-2"
                  >
                    5 semanas de gravidez
                  </Link>
                  <ReactTooltip
                    id="tooltip-2"
                    backgroundColor={Color.roxo}
                    className="tooltip"
                    effect="solid"
                    place="bottom"
                    borderColor={Color.roxo}
                    arrowColor={Color.roxo}
                  />
                </li>
                <li>
                  <Link
                    to="/babypedia/semana-6-da-gravidez/"
                    data-tip="6 semanas de gravidez"
                    className="roxo"
                    data-for="tooltip-3"
                  >
                    6 semanas de gravidez
                  </Link>
                  <ReactTooltip
                    id="tooltip-3"
                    backgroundColor={Color.roxo}
                    className="tooltip"
                    effect="solid"
                    place="bottom"
                    borderColor={Color.roxo}
                    arrowColor={Color.roxo}
                  />
                </li>
                <li>
                  <Link
                    to="/babypedia/semana-7-da-gravidez/"
                    data-tip="7 semanas de gravidez"
                    className="roxo"
                    data-for="tooltip-4"
                  >
                    7 semanas de gravidez
                  </Link>
                  <ReactTooltip
                    id="tooltip-4"
                    backgroundColor={Color.roxo}
                    className="tooltip"
                    effect="solid"
                    place="bottom"
                    borderColor={Color.roxo}
                    arrowColor={Color.roxo}
                  />
                </li>
                <li>
                  <Link
                    to="/babypedia/semana-8-da-gravidez/"
                    data-tip="8 semanas de gravidez"
                    className="roxo last"
                    data-for="tooltip-5"
                  >
                    8 semanas de gravidez
                  </Link>
                  <ReactTooltip
                    id="tooltip-5"
                    backgroundColor={Color.roxo}
                    className="tooltip"
                    effect="solid"
                    place="bottom"
                    borderColor={Color.roxo}
                    arrowColor={Color.roxo}
                  />
                </li>
                <li>
                  <Link
                    to="/babypedia/semana-9-da-gravidez/"
                    data-tip="9 semanas de gravidez"
                    className="laranja"
                    data-for="tooltip-6"
                  >
                    9 semanas de gravidez
                  </Link>
                  <ReactTooltip
                    id="tooltip-6"
                    backgroundColor={Color.laranja}
                    className="tooltip"
                    effect="solid"
                    place="bottom"
                    borderColor={Color.laranja}
                    arrowColor={Color.laranjao}
                  />
                </li>
                <li>
                  <Link
                    to="/babypedia/semana-10-da-gravidez/"
                    data-tip="10 semanas de gravidez"
                    className="laranja"
                    data-for="tooltip-7"
                  >
                    10 semanas de gravidez
                  </Link>
                  <ReactTooltip
                    id="tooltip-7"
                    backgroundColor={Color.laranja}
                    className="tooltip"
                    effect="solid"
                    place="bottom"
                    borderColor={Color.laranja}
                    arrowColor={Color.laranjao}
                  />
                </li>
                <li>
                  <Link
                    to="/babypedia/semana-11-da-gravidez/"
                    data-tip="11 semanas de gravidez"
                    className="laranja"
                    data-for="tooltip-8"
                  >
                    11 semanas de gravidez
                  </Link>
                  <ReactTooltip
                    id="tooltip-8"
                    backgroundColor={Color.laranja}
                    className="tooltip"
                    effect="solid"
                    place="bottom"
                    borderColor={Color.laranja}
                    arrowColor={Color.laranjao}
                  />
                </li>
                <li>
                  <Link
                    to="/babypedia/semana-12-da-gravidez/"
                    data-tip="12 semanas de gravidez"
                    className="laranja last"
                    data-for="tooltip-9"
                  >
                    12 semanas de gravidez
                  </Link>
                  <ReactTooltip
                    id="tooltip-9"
                    backgroundColor={Color.laranja}
                    className="tooltip"
                    effect="solid"
                    place="bottom"
                    borderColor={Color.laranja}
                    arrowColor={Color.laranja}
                  />
                </li>
                <li>
                  <Link
                    to="/babypedia/semana-13-da-gravidez/"
                    data-tip="13 semanas de gravidez"
                    className="rosa"
                    data-for="tooltip-10"
                  >
                    13 semanas de gravidez
                  </Link>
                  <ReactTooltip
                    id="tooltip-10"
                    backgroundColor={Color.rosa}
                    className="tooltip"
                    effect="solid"
                    place="bottom"
                    borderColor={Color.rosa}
                    arrowColor={Color.rosa}
                  />
                </li>
                <li>
                  <Link
                    to="/babypedia/semana-14-da-gravidez/"
                    data-tip="14 semanas de gravidez"
                    className="rosa"
                    data-for="tooltip-11"
                  >
                    14 semanas de gravidez
                  </Link>
                  <ReactTooltip
                    id="tooltip-11"
                    backgroundColor={Color.rosa}
                    className="tooltip"
                    effect="solid"
                    place="bottom"
                    borderColor={Color.rosa}
                    arrowColor={Color.rosa}
                  />
                </li>
                <li>
                  <Link
                    to="/babypedia/semana-15-da-gravidez/"
                    data-tip="15 semanas de gravidez"
                    className="rosa"
                    data-for="tooltip-12"
                  >
                    15 semanas de gravidez
                  </Link>
                  <ReactTooltip
                    id="tooltip-12"
                    backgroundColor={Color.rosa}
                    className="tooltip"
                    effect="solid"
                    place="bottom"
                    borderColor={Color.rosa}
                    arrowColor={Color.rosa}
                  />
                </li>
                <li>
                  <Link
                    to="/babypedia/semana-16-da-gravidez/"
                    data-tip="16 semanas de gravidez"
                    className="rosa last"
                    data-for="tooltip-13"
                  >
                    16 semanas de gravidez
                  </Link>
                  <ReactTooltip
                    id="tooltip-13"
                    backgroundColor={Color.rosa}
                    className="tooltip"
                    effect="solid"
                    place="bottom"
                    borderColor={Color.rosa}
                    arrowColor={Color.rosa}
                  />
                </li>
                <li>
                  <Link
                    to="/babypedia/semana-17-da-gravidez/"
                    data-tip="17 semanas de gravidez"
                    className="amarelo"
                    data-for="tooltip-14"
                  >
                    17 semanas de gravidez
                  </Link>
                  <ReactTooltip
                    id="tooltip-14"
                    backgroundColor={Color.amarelo}
                    className="tooltip"
                    effect="solid"
                    place="bottom"
                    borderColor={Color.amarelo}
                    arrowColor={Color.amarelo}
                  />
                </li>
                <li>
                  <Link
                    to="/babypedia/semana-18-da-gravidez/"
                    data-tip="18 semanas de gravidez"
                    className="amarelo"
                    data-for="tooltip-15"
                  >
                    18 semanas de gravidez
                  </Link>
                  <ReactTooltip
                    id="tooltip-15"
                    backgroundColor={Color.amarelo}
                    className="tooltip"
                    effect="solid"
                    place="bottom"
                    borderColor={Color.amarelo}
                    arrowColor={Color.amarelo}
                  />
                </li>
                <li>
                  <Link
                    to="/babypedia/semana-19-da-gravidez/"
                    data-tip="19 semanas de gravidez"
                    className="amarelo"
                    data-for="tooltip-16"
                  >
                    19 semanas de gravidez
                  </Link>
                  <ReactTooltip
                    id="tooltip-16"
                    backgroundColor={Color.amarelo}
                    className="tooltip"
                    effect="solid"
                    place="bottom"
                    borderColor={Color.amarelo}
                    arrowColor={Color.amarelo}
                  />
                </li>
                <li>
                  <Link
                    to="/babypedia/semana-20-da-gravidez/"
                    data-tip="20 semanas de gravidez"
                    className="amarelo last"
                    data-for="tooltip-17"
                  >
                    20 semanas de gravidez
                  </Link>
                  <ReactTooltip
                    id="tooltip-17"
                    backgroundColor={Color.amarelo}
                    className="tooltip"
                    effect="solid"
                    place="bottom"
                    borderColor={Color.amarelo}
                    arrowColor={Color.amarelo}
                  />
                </li>
                <li>
                  <Link
                    to="/babypedia/semana-21-da-gravidez/"
                    data-tip="21 semanas de gravidez"
                    className="verde"
                    data-for="tooltip-18"
                  >
                    21 semanas de gravidez
                  </Link>
                  <ReactTooltip
                    id="tooltip-18"
                    backgroundColor={Color.verde}
                    className="tooltip"
                    effect="solid"
                    place="bottom"
                    borderColor={Color.verde}
                    arrowColor={Color.verde}
                  />
                </li>
                <li>
                  <Link
                    to="/babypedia/semana-22-da-gravidez/"
                    data-tip="22 semanas de gravidez"
                    className="verde"
                    data-for="tooltip-19"
                  >
                    22 semanas de gravidez
                  </Link>
                  <ReactTooltip
                    id="tooltip-19"
                    backgroundColor={Color.verde}
                    className="tooltip"
                    effect="solid"
                    place="bottom"
                    borderColor={Color.verde}
                    arrowColor={Color.verde}
                  />
                </li>
                <li>
                  <Link
                    to="/babypedia/semana-23-da-gravidez/"
                    data-tip="23 semanas de gravidez"
                    className="verde"
                    data-for="tooltip-20"
                  >
                    23 semanas de gravidez
                  </Link>
                  <ReactTooltip
                    id="tooltip-20"
                    backgroundColor={Color.verde}
                    className="tooltip"
                    effect="solid"
                    place="bottom"
                    borderColor={Color.verde}
                    arrowColor={Color.verde}
                  />
                </li>
                <li>
                  <Link
                    to="/babypedia/semana-24-da-gravidez/"
                    data-tip="24 semanas de gravidez"
                    className="verde last"
                    data-for="tooltip-21"
                  >
                    24 semanas de gravidez
                  </Link>
                  <ReactTooltip
                    id="tooltip-21"
                    backgroundColor={Color.verde}
                    className="tooltip"
                    effect="solid"
                    place="bottom"
                    borderColor={Color.verde}
                    arrowColor={Color.verde}
                  />
                </li>
                <li>
                  <Link
                    to="/babypedia/semana-25-da-gravidez/"
                    data-tip="25 semanas de gravidez"
                    className="roxo"
                    data-for="tooltip-22"
                  >
                    25 semanas de gravidez
                  </Link>
                  <ReactTooltip
                    id="tooltip-22"
                    backgroundColor={Color.roxo}
                    className="tooltip"
                    effect="solid"
                    place="bottom"
                    borderColor={Color.roxo}
                    arrowColor={Color.roxo}
                  />
                </li>
                <li>
                  <Link
                    to="/babypedia/semana-26-da-gravidez/"
                    data-tip="26 semanas de gravidez"
                    className="roxo"
                    data-for="tooltip-23"
                  >
                    26 semanas de gravidez
                  </Link>
                  <ReactTooltip
                    id="tooltip-23"
                    backgroundColor={Color.roxo}
                    className="tooltip"
                    effect="solid"
                    place="bottom"
                    borderColor={Color.roxo}
                    arrowColor={Color.roxo}
                  />
                </li>
                <li>
                  <Link
                    to="/babypedia/semana-27-da-gravidez/"
                    data-tip="27 semanas de gravidez"
                    className="roxo"
                    data-for="tooltip-24"
                  >
                    27 semanas de gravidez
                  </Link>
                  <ReactTooltip
                    id="tooltip-24"
                    backgroundColor={Color.roxo}
                    className="tooltip"
                    effect="solid"
                    place="bottom"
                    borderColor={Color.roxo}
                    arrowColor={Color.roxo}
                  />
                </li>
                <li>
                  <Link
                    to="/babypedia/semana-28-da-gravidez/"
                    data-tip="28 semanas de gravidez"
                    className="roxo last"
                    data-for="tooltip-25"
                  >
                    28 semanas de gravidez
                  </Link>
                  <ReactTooltip
                    id="tooltip-25"
                    backgroundColor={Color.roxo}
                    className="tooltip"
                    effect="solid"
                    place="bottom"
                    borderColor={Color.roxo}
                    arrowColor={Color.roxo}
                  />
                </li>
                <li>
                  <Link
                    to="/babypedia/semana-29-da-gravidez/"
                    data-tip="29 semanas de gravidez"
                    className="laranja"
                    data-for="tooltip-26"
                  >
                    29 semanas de gravidez
                  </Link>
                  <ReactTooltip
                    id="tooltip-26"
                    backgroundColor={Color.laranja}
                    className="tooltip"
                    effect="solid"
                    place="bottom"
                    borderColor={Color.laranja}
                    arrowColor={Color.laranja}
                  />
                </li>
                <li>
                  <Link
                    to="/babypedia/semana-30-da-gravidez/"
                    data-tip="30 semanas de gravidez"
                    className="laranja"
                    data-for="tooltip-27"
                  >
                    30 semanas de gravidez
                  </Link>
                  <ReactTooltip
                    id="tooltip-27"
                    backgroundColor={Color.laranja}
                    className="tooltip"
                    effect="solid"
                    place="bottom"
                    borderColor={Color.laranja}
                    arrowColor={Color.laranja}
                  />
                </li>
                <li>
                  <Link
                    to="/babypedia/semana-31-da-gravidez/"
                    data-tip="31 semanas de gravidez"
                    className="laranja"
                    data-for="tooltip-28"
                  >
                    31 semanas de gravidez
                  </Link>
                  <ReactTooltip
                    id="tooltip-28"
                    backgroundColor={Color.laranja}
                    className="tooltip"
                    effect="solid"
                    place="bottom"
                    borderColor={Color.laranja}
                    arrowColor={Color.laranja}
                  />
                </li>
                <li>
                  <Link
                    to="/babypedia/semana-32-da-gravidez/"
                    data-tip="32 semanas de gravidez"
                    className="laranja last"
                    data-for="tooltip-29"
                  >
                    32 semanas de gravidez
                  </Link>
                  <ReactTooltip
                    id="tooltip-29"
                    backgroundColor={Color.laranja}
                    className="tooltip"
                    effect="solid"
                    place="bottom"
                    borderColor={Color.laranja}
                    arrowColor={Color.laranja}
                  />
                </li>
                <li>
                  <Link
                    to="/babypedia/semana-33-da-gravidez/"
                    data-tip="33 semanas de gravidez"
                    className="rosa"
                    data-for="tooltip-30"
                  >
                    33 semanas de gravidez
                  </Link>
                  <ReactTooltip
                    id="tooltip-30"
                    backgroundColor={Color.rosa}
                    className="tooltip"
                    effect="solid"
                    place="bottom"
                    borderColor={Color.rosa}
                    arrowColor={Color.rosa}
                  />
                </li>
                <li>
                  <Link
                    to="/babypedia/semana-34-da-gravidez/"
                    data-tip="34 semanas de gravidez"
                    className="rosa"
                    data-for="tooltip-31"
                  >
                    34 semanas de gravidez
                  </Link>
                  <ReactTooltip
                    id="tooltip-31"
                    backgroundColor={Color.rosa}
                    className="tooltip"
                    effect="solid"
                    place="bottom"
                    borderColor={Color.rosa}
                    arrowColor={Color.rosa}
                  />
                </li>
                <li>
                  <Link
                    to="/babypedia/semana-35-da-gravidez/"
                    data-tip="35 semanas de gravidez"
                    className="rosa"
                    data-for="tooltip-32"
                  >
                    35 semanas de gravidez
                  </Link>
                  <ReactTooltip
                    id="tooltip-32"
                    backgroundColor={Color.rosa}
                    className="tooltip"
                    effect="solid"
                    place="bottom"
                    borderColor={Color.rosa}
                    arrowColor={Color.rosa}
                  />
                </li>
                <li>
                  <Link
                    to="/babypedia/semana-36-da-gravidez/"
                    data-tip="36 semanas de gravidez"
                    className="rosa last"
                    data-for="tooltip-33"
                  >
                    36 semanas de gravidez
                  </Link>
                  <ReactTooltip
                    id="tooltip-33"
                    backgroundColor={Color.rosa}
                    className="tooltip"
                    effect="solid"
                    place="bottom"
                    borderColor={Color.rosa}
                    arrowColor={Color.rosa}
                  />
                </li>
                <li>
                  <Link
                    to="/babypedia/semana-37-da-gravidez/"
                    data-tip="37 semanas de gravidez"
                    className="amarelo"
                    data-for="tooltip-34"
                  >
                    37 semanas de gravidez
                  </Link>
                  <ReactTooltip
                    id="tooltip-34"
                    backgroundColor={Color.amarelo}
                    className="tooltip"
                    effect="solid"
                    place="bottom"
                    borderColor={Color.amarelo}
                    arrowColor={Color.amarelo}
                  />
                </li>
                <li>
                  <Link
                    to="/babypedia/semana-38-da-gravidez/"
                    data-tip="38 semanas de gravidez"
                    className="amarelo"
                    data-for="tooltip-35"
                  >
                    38 semanas de gravidez
                  </Link>
                  <ReactTooltip
                    id="tooltip-35"
                    backgroundColor={Color.amarelo}
                    className="tooltip"
                    effect="solid"
                    place="bottom"
                    borderColor={Color.amarelo}
                    arrowColor={Color.amarelo}
                  />
                </li>
                <li>
                  <Link
                    to="/babypedia/semana-39-da-gravidez/"
                    data-tip="39 semanas de gravidez"
                    className="amarelo"
                    data-for="tooltip-36"
                  >
                    39 semanas de gravidez
                  </Link>
                  <ReactTooltip
                    id="tooltip-36"
                    backgroundColor={Color.amarelo}
                    className="tooltip"
                    effect="solid"
                    place="bottom"
                    borderColor={Color.amarelo}
                    arrowColor={Color.amarelo}
                  />
                </li>
                <li>
                  <Link
                    to="/babypedia/recem-nascido/"
                    data-tip="Recém-nascido"
                    className="amarelo last"
                    data-for="tooltip-37"
                  >
                    Recém-nascido
                  </Link>
                  <ReactTooltip
                    id="tooltip-37"
                    backgroundColor={Color.amarelo}
                    className="tooltip"
                    effect="solid"
                    place="bottom"
                    borderColor={Color.amarelo}
                    arrowColor={Color.amarelo}
                  />
                </li>
              </ul>
            </>
          ) : (
            ''
          )}
        </LinhaDoTempo>
      )}
      {isMobile && (
        <LinhaDoTempo>
          {title ? '' : <h2>Babypedia</h2>}
          <Slider
            infinite
            swipeToSlide
            speed={250}
            slidesToShow={5}
            slidesToScroll={5}
            centerPadding="1em"
            nextArrow={<NextArrow />}
            prevArrow={<PrevArrow />}
          >
            <Link to="/babypedia/semana-4-da-gravidez/" className="verde">
              4
            </Link>
            <Link to="/babypedia/semana-5-da-gravidez/" className="roxo">
              5
            </Link>
            <Link to="/babypedia/semana-6-da-gravidez/" className="roxo">
              6
            </Link>
            <Link to="/babypedia/semana-7-da-gravidez/" className="roxo">
              7
            </Link>
            <Link to="/babypedia/semana-8-da-gravidez/" className="roxo">
              8
            </Link>
            <Link to="/babypedia/semana-9-da-gravidez/" className="laranja">
              9
            </Link>
            <Link to="/babypedia/semana-10-da-gravidez/" className="laranja">
              10
            </Link>
            <Link to="/babypedia/semana-11-da-gravidez/" className="laranja">
              11
            </Link>
            <Link to="/babypedia/semana-12-da-gravidez/" className="laranja">
              12
            </Link>
            <Link to="/babypedia/semana-13-da-gravidez/" className="rosa">
              13
            </Link>
            <Link to="/babypedia/semana-14-da-gravidez/" className="rosa">
              14
            </Link>
            <Link to="/babypedia/semana-15-da-gravidez" className="rosa">
              15
            </Link>
            <Link to="/babypedia/semana-16-da-gravidez/" className="rosa">
              16
            </Link>
            <Link to="/babypedia/semana-17-da-gravidez/" className="amarelo">
              17
            </Link>
            <Link to="/babypedia/semana-18-da-gravidez/" className="amarelo">
              18
            </Link>
            <Link to="/babypedia/semana-19-da-gravidez/" className="amarelo">
              19
            </Link>
            <Link to="/babypedia/semana-20-da-gravidez/" className="amarelo">
              20
            </Link>
            <Link to="/babypedia/semana-21-da-gravidez/" className="verde">
              21
            </Link>
            <Link to="/babypedia/semana-22-da-gravidez/" className="verde">
              22
            </Link>
            <Link to="/babypedia/semana-23-da-gravidez/" className="verde">
              23
            </Link>
            <Link to="/babypedia/semana-24-da-gravidez/" className="verde">
              24
            </Link>
            <Link to="/babypedia/semana-25-da-gravidez/" className="roxo">
              25
            </Link>
            <Link to="/babypedia/semana-26-da-gravidez/" className="roxo">
              26
            </Link>
            <Link to="/babypedia/semana-27-da-gravidez/" className="roxo">
              27
            </Link>
            <Link to="/babypedia/semana-28-da-gravidez/" className="roxo">
              28
            </Link>
            <Link to="/babypedia/semana-29-da-gravidez/" className="laranja">
              29
            </Link>
            <Link to="/babypedia/semana-30-da-gravidez/" className="laranja">
              30
            </Link>
            <Link to="/babypedia/semana-31-da-gravidez/" className="laranja">
              31
            </Link>
            <Link to="/babypedia/semana-32-da-gravidez/" className="laranja">
              32
            </Link>
            <Link to="/babypedia/semana-33-da-gravidez/" className="rosa">
              33
            </Link>
            <Link to="/babypedia/semana-34-da-gravidez/" className="rosa">
              34
            </Link>
            <Link to="/babypedia/semana-35-da-gravidez/" className="rosa">
              35
            </Link>
            <Link to="/babypedia/semana-36-da-gravidez/" className="rosa">
              36
            </Link>
            <Link to="/babypedia/semana-37-da-gravidez/" className="amarelo">
              37
            </Link>
            <Link to="/babypedia/semana-38-da-gravidez/" className="amarelo">
              38
            </Link>
            <Link to="/babypedia/semana-39-da-gravidez/" className="amarelo">
              39
            </Link>
            <Link to="/babypedia/recem-nascido/" className="amarelo">
              0
            </Link>
          </Slider>
        </LinhaDoTempo>
      )}
    </Container>
  )
}

export default Babypedia
